module.exports = __webpack_public_path__ + "static/media/solvedToday.80e963b2.svg";